export default __webpack_public_path__ + "static/media/promo-muggle-murders-rise_01.0c266fd2.jpg";